import { ChakraProvider, HStack, Icon, Link, Text } from "@chakra-ui/react";
import { FaInstagram, FaYoutube } from "react-icons/fa";
import { Link as RouterLink } from "react-router-dom";
import FraudCardGerman from "./FraudCardGerman";

function MarioGermanPage() {
  return (
    <ChakraProvider>
      <FraudCardGerman
        fraudsterName="Mario Grasböck (Grasbeck/Grasbock)"
        fraudsterImage={require("../assets/mario2.png")}
        estimatedMoneyLost="550.000$ - 2Mio$"
        socialMediaLinks={
          <HStack spacing={4} mt={2}>
            <Link
              href="https://www.youtube.com/@MarioGrasbock"
              cursor="pointer"
              isExternal
            >
              <Icon as={FaYoutube} boxSize={6} color="red.500" />
            </Link>
            <Link
              href="https://www.instagram.com/mario_grasboeck_"
              cursor="pointer"
              isExternal
            >
              <Icon as={FaInstagram} boxSize={6} color="purple.500" />
            </Link>
          </HStack>
        }
        fraudsterDescription={
          <div>
            <Text fontSize="sm" color="gray.600" fontStyle="italic" mb={5}>
              <RouterLink
                to="/"
                style={{
                  textDecoration: "none",
                  color: "#3182ce",
                  fontWeight: "bold",
                }}
              >
                → English version / Englische Version
              </RouterLink>
            </Text>
            <Text>
              Mario Grasbock ist ein Betrüger und Schwindler, der viele
              Betrügereien und Geldwäscheverbrechen begangen hat. Er ist ein
              geschickter Manipulator und zeigt Anzeichen von
              <Link
                href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4321752/#:~:text=Psychopathy%20is%20a%20neuropsychiatric%20disorder,antisocial%20deviance%20and%20criminal%20behavior."
                isExternal
                color="blue.600"
              >
                {" "}
                Psychopathie
              </Link>{" "}
              oder
              <Link
                href="https://www.mayoclinic.org/diseases-conditions/antisocial-personality-disorder/symptoms-causes/syc-20353928#:~:text=Antisocial%20personality%20disorder%2C%20sometimes%20called,rights%20and%20feelings%20of%20others."
                isExternal
                color="blue.600"
              >
                {" "}
                Soziopathie
              </Link>{" "}
              wie mangelnde Reue, hinterhältige Manipulation, mangelndes
              Mitgefühl (aber eine unheimliche Fähigkeit, es zu imitieren),
              chronisches Lügen und Impulsivität. <br /> <br />
              Mario hat mehrere Menschen betrogen, indem er behauptete, ein
              Investor zu sein, der ihnen helfen möchte. Er behauptet auch, ein
              Heiler zu sein und nutzt Meditation, um Opfer dazu zu verleiten,
              ihm zu vertrauen. Er erzählt ihnen oft, dass er die reine Absicht
              hat, ein Wellness-Zentrum zu bauen, um Menschen und Tiere zu
              heilen. Was wir bisher wissen ist, dass Mario Vertrauen aufbaut,
              um seine Opfer auszunutzen. Bedenken Sie, Mario ist wirklich
              geschickt im Lügen und Manipulieren und kann wahrheitsgemäß
              klingen, aber seine Taten entsprechen nicht seinen Worten.
            </Text>
            <br />
          </div>
        }
        partners={[
          {
            name: "Matthew Lobene",
          },
          {
            name: (
              <RouterLink to="/joshua-koch" style={{ textDecoration: "none" }}>
                <Text
                  display="inline"
                  color="blue.600"
                  _hover={{
                    color: "blue.800",
                    textDecoration: "underline",
                    fontWeight: "bold",
                  }}
                  transition="all 0.2s ease-in-out"
                >
                  Joshua Staurt Koch (Joshua Koch, Josh S. Koch)
                </Text>
              </RouterLink>
            ),
            socialHandleLink:
              "https://www.linkedin.com/in/josh-s-koch-0529379b",
          },
          {
            name: "Rafael Lopes Brasileiro Martim",
          },
        ]}
        spouses={[
          {
            name: "@_mrs_leela",
            socialHandleLink: "https://www.instagram.com/_mrs_leela/",
            ex: true,
          },
        ]}
        techniques={[
          "Komplimente und Love-Bombing der Opfer.",
          "Langfristige Betrügereien nach dem Aufbau von Vertrauen über die Zeit.",
          "Versendung gefälschter Kontostand- und Überweisungsauszüge.",
          "Meditation mit seinen Opfern und gemeinsame Erfahrungen zum Vertrauensaufbau.",
          "Identifizierung eines Bedürfnisses, das das Opfer wünscht, und Vortäuschung der Fähigkeit, es zu erfüllen.",
          "Verwendung einer fiktiven Geschichte über seinen Wunsch, eine Heilungsstiftung zu gründen.",
        ]}
        documents={[
          require("../assets/pdfs/mario/Mario.pdf"),
          require("../assets/pdfs/mario/DBFraud-Notice.pdf"),
          require("../assets/pdfs/mario/GeoCoreFakeContract.pdf"),
          require("../assets/pdfs/mario/ANDRASTER-CIS.pdf"),
          require("../assets/pdfs/mario/fakeBalance.pdf"),
        ]}
        images={[
          require("../assets/mario1.png"),
          require("../assets/mario3.png"),
          require("../assets/mario4.png"),
        ]}
        voiceSamples={[
          require("../assets/audio/mario1.ogg"),
          require("../assets/audio/mario2.ogg"),
        ]}
        educationalMedia={[
          {
            displayName: "Was ist ein Psychopath?",
            link: "https://www.verywellmind.com/what-is-a-psychopath-5025217",
          },
          {
            displayName: "Narzisst, Psychopath oder Soziopath?",
            link: "https://www.youtube.com/watch?v=6dv8zJiggBs&ab_channel=MedCircle",
          },
          {
            displayName: "7 Eigenschaften des modernen Psychopathen",
            link: "https://www.psychologytoday.com/us/blog/communication-success/201810/7-characteristics-of-the-modern-psychopath",
          },
          {
            displayName: "Vier Wege, einen Betrüger zu erkennen",
            link: "https://www.cnbc.com/2020/01/03/four-sure-fire-ways-to-spot-a-con-artistand-what-to-do-when-you-see-them.html",
          },
        ]}
      />
    </ChakraProvider>
  );
}

export default MarioGermanPage;
